import { useState } from "react";
import { handleData } from "../../api";
import { MdOutlineCancel } from 'react-icons/md';


const AdminVoltooideTaak = (props) => {


    const { taak, users, loadingData, handleVerwijdering } = props;
    const { taakID, activiteitDatum, activiteitNaam, taakNaam, dagdeel, activiteitID, vrijwilliger, taakVoltooid } = taak;
    const [ selectVrijwilliger, setSelectVrijwilliger] = useState(false);
    const [newVrijwilliger, setNewVrijwilliger] = useState({
        update: {
            field: "vrijwilliger",
            value: ""
        },
        needConfirm: false
    });

    const handleSelectVrijwilliger = (e) => {
        setNewVrijwilliger({
            update: {
                ...newVrijwilliger.update,
                value: e.target.value
            },
            needConfirm: true
        });
    }

    const handleConfirmAddVrijwilliger = async() => {
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const input = {
            'taken.$.vrijwilliger': newVrijwilliger.update.value
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const addedVrijwilliger = await handleData(data);

        setSelectVrijwilliger(false);
        setNewVrijwilliger({
            update: {
                field: "vrijwilliger",
                value: ""
            },
            needConfirm: false
        });
        loadingData();
    }

    const handleVrijwilligerDropDown = () => {
        if(selectVrijwilliger && newVrijwilliger.needConfirm) {
            setNewVrijwilliger({
                update: {
                    field: "vrijwilliger",
                    value: ""
                },
                needConfirm: false
            });
        }
        setSelectVrijwilliger(() => !selectVrijwilliger );
    }

    const handleConfirmVrijwilligerVoltooid = async () => {
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const input = {
            'taken.$.vrijwilligervoltooid': true
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const bevestigdeVrijwilligerTaakVoltooid = await handleData(data);
        loadingData();

    }

    return (
        <>
            <tr>
                <td>{activiteitDatum}</td>
                <td>{activiteitNaam}</td>
                <td>{taakNaam}</td>
                <td>{dagdeel}</td>
                <td>
                    { !vrijwilliger &&
                    <button onClick={handleVrijwilligerDropDown} > {selectVrijwilliger ? "x" : "+"}</button>
                    }
                </td>
                <td>{ vrijwilliger ||
                    ( selectVrijwilliger &&
                    <select 
                        name="vrijwilliger" 
                        id="vrijwilliger" 
                        onChange={handleSelectVrijwilliger}
                        value={newVrijwilliger.update.value}
                    >
                        <option value="" >Selecteer een vrijwilliger</option>
                        {users.map(item => {
                            return <option key={item._id} value={item._id}>{item.naam}</option>
                        })}
                    </select>
                    )
                    }
                </td>
                <td>
                    {newVrijwilliger.needConfirm && <button onClick={handleConfirmAddVrijwilliger}>Bevestig</button>}
                </td>
                <td>
                    {!taakVoltooid &&(vrijwilliger &&
                        <button onClick={handleConfirmVrijwilligerVoltooid}>
                            Bevestig
                        </button>
                    )
                    }
                    
                </td>
                <td>
                    {taakVoltooid && "Bevestigd"}
                </td>
                <td>
                    <button className="verwijder" onClick={() => handleVerwijdering(taakID, activiteitID)}>
                        <span><MdOutlineCancel /></span>
                    </button>

                </td>
            </tr>
        </>
    );
}

export default AdminVoltooideTaak;